import {useEffect, useRef} from "react";
import {
  getDailyStatisticsApi,
  getMonthlyStatisticsApi, getNewDailyStatisticsApi, getNewMonthlyStatisticsApi,
  getNewYearlyStatisticsApi,
  getYearlyStatisticsApi
} from "api/statisticsApi";

export const useGetYearlyStatisticsApi = (setters, data) => {
  const previousDataRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      if (data.shopId) {
        try {
          const getData = await getYearlyStatisticsApi(data);

          setters.setYearDataList?.(getData);
        } catch (e) {
          console.error(e);
        }
      }
    };

    if (JSON.stringify(previousDataRef.current) !== JSON.stringify(data)) {
      fetchData();
      previousDataRef.current = data;
    }
  }, [data, setters]);
};

export const useGetMonthlyStatisticsApi = (setters, data) => {
  const previousDataRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      if (data.shopId) {
        try {
          const getData = await getMonthlyStatisticsApi(data);

          setters.setMonthDataList?.(getData);
        } catch (e) {
          console.error(e);
        }
      }
    };

    if (JSON.stringify(previousDataRef.current) !== JSON.stringify(data)) {
      fetchData();
      previousDataRef.current = data;
    }
  }, [data, setters]);
};

export const useGetDailyStatisticsApi = (setters, data) => {
  const previousDataRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      if (data.date) {
        try {
          const getData = await getDailyStatisticsApi(data);

          setters.setDayDataList?.(getData);
        } catch (e) {
          console.error(e);
        }
      }
    };

    if (JSON.stringify(previousDataRef.current) !== JSON.stringify(data)) {
      fetchData();
      previousDataRef.current = data;
    }
  }, [data, setters]);
};

export const useGetNewYearlyStatisticsApi = (setters, data) => {
  const previousDataRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const getData = await getNewYearlyStatisticsApi(data);
        console.log(getData);
        setters.setYearDataList?.(getData);
      } catch (e) {
        console.error(e);
      }
    };

    if (JSON.stringify(previousDataRef.current) !== JSON.stringify(data)) {
      fetchData();
      previousDataRef.current = data;
    }
  }, [data, setters]);
};

export const useGetNewMonthlyStatisticsApi = (setters, data) => {
  const previousDataRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const getData1 = await getNewMonthlyStatisticsApi({
          year: data.year,
          month: data.month,
          deliveryType: data.deliveryType
        });

        let getData2 = []

        if (data.date) {
          getData2 = await getNewDailyStatisticsApi({
            date: data.date,
            deliveryType: data.deliveryType
          });
        }

        setters.setMonthDataList?.(getData1);
        setters.setDayDataList?.(getData2);
      } catch (e) {
        console.error(e);
      }
    };

    if (JSON.stringify(previousDataRef.current) !== JSON.stringify(data)) {
      fetchData();
      previousDataRef.current = data;
    }
  }, [data, setters]);
};



